export const SelectModes = {
    SELECT: 'select',
    UNSELECT: 'unselect',
};
